import { useTranslation } from 'react-i18next'

import { CloudQuestionIcon } from 'src/assets/icons'

import { CloseAccountMobile } from './close-account-mobile.component'
import { SettingsDropdownMobile } from 'src/components'
import { ExposePrivateKeyButton } from 'src/components/expose-private-key-modal/expose-private-key-button.component'
import { useRequestAccountPrivateKey, useVerifyAccountPrivateKeyRequest } from 'src/hooks'
import { PrivateKeyRequestFn, PrivateKeyVerifyFn } from 'src/types'

import { SPACES } from 'src/constants'
import { useStyles } from '../styles'

const MobileSettings = () => {
  const [t] = useTranslation()
  const classes = useStyles()

  const handleHelpClick = () => {
    window.Intercom('show')
  }

  return (
    <div style={{ marginTop: SPACES.m }} className={classes.settingsWrapper}>
      <ExposePrivateKeyButton
        verifyFn={useVerifyAccountPrivateKeyRequest as PrivateKeyVerifyFn}
        requestFn={useRequestAccountPrivateKey as PrivateKeyRequestFn}
        mobile
      />
      <SettingsDropdownMobile
        handleClick={handleHelpClick}
        icon={CloudQuestionIcon}
        label={t('account-support-help-section.v')}
      />

      <CloseAccountMobile />
    </div>
  )
}

export { MobileSettings }
